import React from "react";

export default class EmptyFieldList extends React.Component {
    render () {
        return (
            <div className="disabled">
                <div style={{paddingLeft: "20px"}}>There are no fields available for mapping.</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/lib/mapping/views/recordsourcetreegrid/EmptyFieldList.js